// Classic countdown: counted transactions until the next receiver cycle, not payments owed.
export function getRemainingTransactions(counter, milestone) {
  if (!Number.isSafeInteger(Number(counter)) || Number(counter) < 0 || !Number.isSafeInteger(Number(milestone)) || Number(milestone) <= 0) return null;
  return Number(milestone) - (Number(counter) % Number(milestone));
}
